import { useCallback } from "react";
import { BulletedListButton } from "../message/editor/plugins/toolbar/bulleted-list-button";
import { OrderedListButton } from "../message/editor/plugins/toolbar/ordered-list-button";
import { ButtonMenu } from "./button-menu";

import type { ToolbarProps } from "../message/editor/plugins/toolbar/props";
import type { MenuContext } from "./use-menu-reducer";
import type { IconButtonProps } from "@mui/material";
import type { FC } from "react";

export const ListMenu: FC<ToolbarProps & { menu: MenuContext; activeBlockType: string }> = ({
  menu,
  activeBlockType,
  disabled,
}) => {
  const makeButton = useCallback(
    (buttonProps: IconButtonProps & { onClick?: () => void }) =>
      activeBlockType === "number" ? (
        <OrderedListButton activeBlockType {...buttonProps} />
      ) : (
        <BulletedListButton activeBlockType={activeBlockType === "bullet"} {...buttonProps} />
      ),
    [activeBlockType],
  );

  return (
    <ButtonMenu
      button={makeButton}
      disabled={disabled}
      open={menu.state.list.isOpen}
      onClose={menu.close("list")}
      onOpen={menu.open("list")}
      title="List menu"
    >
      <BulletedListButton
        disabled={disabled}
        label="Bulleted list"
        onClick={menu.close("list")}
        activeBlockType={activeBlockType === "bullet"}
      />
      <OrderedListButton
        disabled={disabled}
        label="Ordered list"
        onClick={menu.close("list")}
        activeBlockType={activeBlockType === "number"}
      />
    </ButtonMenu>
  );
};
